module.exports = __webpack_public_path__ + "static/media/webWhite-moth-on-black-screen_h7yjnx_c_scale,w_1347.adfe6971.gif";